import { RLogementCompoEHPADSchema_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'
const Data = require('../json/EHPADcompositionECS.json')

//CoefficientMajorationBatimentSorted
export function fetchRLogementCompoEHPAD(uuid: string): RLogementCompoEHPADSchema_Type {
  return fetchGeneric(Data, uuid)
}

export function fetchRLogementCompoEHPADSorted(): Array<{ value: string; label: string }> {
  return fetchGenericSorted(Data)
}
